import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-soft-skill',
  templateUrl: './soft-skill.component.html',
  styleUrls: ['./soft-skill.component.scss']
})
export class SoftSkillComponent implements OnInit {
  pdfSrc: string = 'https://drive.google.com/file/d/1npgGgMjHMWMZ3r7g6WydyH01LThPXalK/preview';
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc;
  }

}
